export enum ThirdPartyLogos {
  APPLE = "/icons/apple_podcasts/apple_podcasts_logo_without_text.svg",
  APPLE_BLACK = "/icons/apple_podcasts/applepodcasts_black.svg",
  APPLE_WHITE = "/icons/apple_podcasts/applepodcasts_white.svg",
  SPOTIFY_BLACK = "/icons/spotify/spotify_logo_without_text_black.svg",
  SPOTIFY_GREEN = "/icons/spotify/spotify_logo_without_text_green.svg",
  SPOTIFY_WHITE = "/icons/spotify/spotify_logo_without_text_white.svg",
  OPEN_COLLECTIVE = "/icons/opencollective.svg",
}
